import { memo, useEffect, useRef } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "./style.scss";
import { ROUTERS } from "utils/router";
import React, { useState } from 'react';
import GetStartedButton from "../../../../component/GetStartedButton";
import Notification from "../../../../component/Notification";
import { getUserInfo, saveUserInfo } from "utils/localStorage";
import { getUserinfo } from "api/User.api";
import { MdKeyboardArrowDown, MdLogout } from "react-icons/md";
import { AiOutlineProfile } from "react-icons/ai";
import { IoCreateOutline } from "react-icons/io5";
export const categories = [
    "Milk-tea",
    "Fruit-tea",
];
const Header = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [isShowHumberger, setShowHumberger] = useState(false);
    const [isHome, setIsHome] = useState(location.pathname.length <= 1);
    const [isShowCategories, setShowCategories] = useState(isHome);
    const [menus, setMenus] = useState([
        {
            name: "Home",
            path: ROUTERS.USER.HOME,
        },
        {
            name: "Dashboard",
            path: "/dashboard/all",
            isShowSubmenu: false,
            child: [
                {
                    name: "Posted",
                    path: "/dashboard/posted",
                },
                {
                    name: "Pending",
                    path: "/dashboard/pending",
                },
            ]
        },
        {
            name: "My Capsules",
            path: "/my-capsule/all",
            isShowSubmenu: false,
            child: [
                {
                    name: "Posted",
                    path: "/my-capsule/posted",
                },
                {
                    name: "Pending",
                    path: "/my-capsule/pending",
                },
            ]
        },
        {
            name: "Friends",
            path: ROUTERS.USER.FRIENDS,
        },

    ]);

    const user = getUserInfo(); // State to store logged-in user

    useEffect(() => {
        const isHome = location.pathname.length <= 1;
        setIsHome(isHome);
        setShowCategories(isHome);
    }, [location.pathname]);


    const handleLoginSuccess = async (loggedInUser) => {
        try {
            console.log("User received from login:", loggedInUser);

            // Call the API to get the user's information
            const userInfo = await getUserinfo();

            // Save the user information to localStorage
            saveUserInfo(userInfo);

            console.log("User info saved to localStorage:", userInfo);

            // Optionally reload the page to reflect the new state
            setTimeout(() => {
                window.location.reload();
            }, 100);
        } catch (error) {
            console.error("Failed to fetch user info:", error);
        }
    };

    const closeHamburgerMenu = () => {
        setShowHumberger(false); // Close the hamburger menu
    };
    const [isOpen, setIsOpen] = useState(false);
    const menuRef = useRef();

    const toggleDropdown = () => setIsOpen(!isOpen);
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);
    return (<>
        <div className={`humberger__menu__overlay${isShowHumberger ? " active" : ""}`}
            onClick={() => setShowHumberger(false)}
        />
        <div className={`humberger__menu__wrapper${isShowHumberger ? " show" : ""}`}>
            <div className="header__logo">
                <h1>EchoVault</h1>
            </div>
            <div className="humberger__menu__widget">
                <div className="header__top__right__auth">
                    {user ? (
                        <div className="user-avatar-hum">
                            <div className="hum-avt">
                                <img
                                    src={user.data.avatar || "/default-avatar.jpeg"}
                                    alt="User Avatar"
                                    className="avatar"
                                />
                                <span>{user.data.displayName}</span>
                            </div>
                            <div className="user-func">
                                <div onClick={() => navigate(ROUTERS.USER.PROFILE)}><AiOutlineProfile />  Profile</div>
                                <div onClick={() => navigate(ROUTERS.USER.CREATE)}><IoCreateOutline />  New Capsule</div>
                                <div
                                    onClick={() => {
                                        localStorage.clear(); // Clear all data from localStorage
                                        alert("You have been logged out.");
                                        window.location.reload(); // Optionally reload the page to reflect the logout state
                                    }}
                                >
                                    <MdLogout />  Logout
                                </div>
                            </div>

                        </div>
                    ) : (
                        <GetStartedButton onLoginSuccess={handleLoginSuccess}
                            onCloseHamburger={closeHamburgerMenu} // Pass the function to close the menu
                        />

                    )}
                </div>
            </div>
            <div className="humberger__menu__nav">
                <ul>
                    {
                        menus.map((menu, menuKey) => (
                            <li key={menuKey} to={menu.path}>
                                <Link to={menu.path}
                                    onClick={() => {
                                        const newMenus = [...menus];
                                        newMenus[menuKey].isShowSubmenu = !newMenus[menuKey].isShowSubmenu;
                                        setMenus(newMenus);
                                    }}>
                                    {menu.name}
                                    {menu.child && (
                                        menu.isShowSubmenu ? (
                                            <svg width="20px" height="20px" viewBox="-0.5 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M12 22.4199C17.5228 22.4199 22 17.9428 22 12.4199C22 6.89707 17.5228 2.41992 12 2.41992C6.47715 2.41992 2 6.89707 2 12.4199C2 17.9428 6.47715 22.4199 12 22.4199Z" stroke="#000000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                <path d="M16 10.99L13.13 14.05C12.9858 14.2058 12.811 14.3298 12.6166 14.4148C12.4221 14.4998 12.2122 14.5437 12 14.5437C11.7878 14.5437 11.5779 14.4998 11.3834 14.4148C11.189 14.3298 11.0142 14.2058 10.87 14.05L8 10.99" stroke="#000000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                            </svg>
                                        ) : (
                                            <svg width="20px" height="20px" viewBox="-0.5 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M12 22.4199C17.5228 22.4199 22 17.9428 22 12.4199C22 6.89707 17.5228 2.41992 12 2.41992C6.47715 2.41992 2 6.89707 2 12.4199C2 17.9428 6.47715 22.4199 12 22.4199Z" stroke="#000000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                <path d="M8 13.8599L10.87 10.8C11.0125 10.6416 11.1868 10.5149 11.3815 10.4282C11.5761 10.3415 11.7869 10.2966 12 10.2966C12.2131 10.2966 12.4239 10.3415 12.6185 10.4282C12.8132 10.5149 12.9875 10.6416 13.13 10.8L16 13.8599" stroke="#000000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                            </svg>
                                        )
                                    )}
                                </Link>
                                {menu.child &&
                                    (<ul className={`header__menu__dropdown ${menu.isShowSubmenu ? "show__submenu" : ""}`}>
                                        {menu.child.map((childItem, childKey) => (
                                            <li key={`${menuKey}-${childKey}`}>
                                                <Link to={childItem.path}>{childItem.name}</Link>
                                            </li>
                                        ))}
                                    </ul>)}
                            </li>
                        ))}
                </ul>
            </div>
            <div className="header__top__right__social">
                <Link to="https://facebook.com">
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 50 50">
                        <path d="M40,0H10C4.486,0,0,4.486,0,10v30c0,5.514,4.486,10,10,10h30c5.514,0,10-4.486,10-10V10C50,4.486,45.514,0,40,0z M39,17h-3 c-2.145,0-3,0.504-3,2v3h6l-1,6h-5v20h-7V28h-3v-6h3v-3c0-4.677,1.581-8,7-8c2.902,0,6,1,6,1V17z">
                        </path>
                    </svg>
                </Link>

                <Link to="https://instagram.com">
                    <svg fill="#000000" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 169.063 169.063">
                        <g>
                            <path d="M122.406,0H46.654C20.929,0,0,20.93,0,46.655v75.752c0,25.726,20.929,46.655,46.654,46.655h75.752c25.727,0,46.656-20.93,46.656-46.655V46.655C169.063,20.93,148.133,0,122.406,0z M154.063,122.407c0,17.455-14.201,31.655-31.656,31.655H46.654C29.2,154.063,15,139.862,15,122.407V46.655C15,29.201,29.2,15,46.654,15h75.752c17.455,0,31.656,14.201,31.656,31.655V122.407z" />
                            <path d="M84.531,40.97c-24.021,0-43.563,19.542-43.563,43.563c0,24.02,19.542,43.561,43.563,43.561s43.563-19.541,43.563-43.561C128.094,60.512,108.552,40.97,84.531,40.97z M84.531,113.093c-15.749,0-28.563-12.812-28.563-28.561c0-15.75,12.813-28.563,28.563-28.563s28.563,12.813,28.563,28.563C113.094,100.281,100.28,113.093,84.531,113.093z" />
                            <path d="M129.921,28.251c-2.89,0-5.729,1.17-7.77,3.22c-2.051,2.04-3.23,4.88-3.23,7.78c0,2.891,1.18,5.73,3.23,7.78c2.04,2.04,4.88,3.22,7.77,3.22c2.9,0,5.73-1.18,7.78-3.22c2.05-2.05,3.22-4.89,3.22-7.78c0-2.9-1.17-5.74-3.22-7.78C135.661,29.421,132.821,28.251,129.921,28.251z" />
                        </g>
                    </svg>
                </Link>
            </div>
            <div className="humberger__menu__contact">
                <ul>
                    <li>
                        <svg fill="#000000" height="13px" width="13px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">

                            <g>
                                <path d="M410.272,243.145c-3.63-4.486-10.211-5.179-14.695-1.548l-3.636,2.942c-4.485,3.631-5.177,10.211-1.546,14.696
			c2.066,2.551,5.083,3.875,8.128,3.875c2.309,0,4.634-0.762,6.568-2.328l3.635-2.942
			C413.21,254.209,413.903,247.63,410.272,243.145z"/>
                            </g>
                            <g>
                                <path d="M380.363,267.357c-3.63-4.486-10.211-5.179-14.695-1.549l-74.708,59.674c-4.485,3.631-5.177,10.21-1.546,14.695
			c2.064,2.551,5.082,3.875,8.127,3.875c2.309,0,4.634-0.762,6.568-2.327l74.708-59.674
			C383.301,278.421,383.994,271.843,380.363,267.357z"/>
                            </g>
                            <g>
                                <path d="M449.742,62.685H62.258C27.929,62.685,0,90.614,0,124.942v262.117c0,34.329,27.929,62.257,62.258,62.257h387.484
			c34.33,0,62.258-27.928,62.258-62.257V124.942C512,90.614,484.072,62.685,449.742,62.685z M419.912,83.582L255.859,216.19
			L91.806,83.582H419.912z M428.126,428.418H83.592V184.382l165.712,133.49c3.826,3.082,9.284,3.082,13.11,0l165.711-133.49V428.418
			z M491.102,387.058c0,22.806-18.554,41.359-41.36,41.359h-0.717v-265.87c0-4.023-2.309-7.688-5.939-9.425
			c-3.632-1.738-7.934-1.235-11.065,1.288L255.859,296.318L79.697,154.41c-3.134-2.523-7.438-3.026-11.065-1.288
			c-3.63,1.737-5.939,5.402-5.939,9.425v265.87h-0.436c-22.805,0.001-41.359-18.553-41.359-41.358V124.942
			c0-21.626,16.688-39.418,37.861-41.2l190.532,154.012c1.915,1.549,4.242,2.323,6.568,2.323c2.327,0,4.653-0.774,6.568-2.323
			L452.983,83.721c21.295,1.66,38.119,19.507,38.119,41.22V387.058z"/>
                            </g>
                        </svg>
                        echovaultsupport@gmail.com
                    </li>
                    <li>Preserve your memories forever with EchoVault </li>
                </ul>
            </div>
        </div>

        <div className="header__top">
            <div className="container">
                <div className="row">
                    <div className="col-6 header__top_left">
                        <ul>
                            <li>
                                <svg fill="#ffffff" height="14" width="14" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                                    <g>
                                        <path d="M410.272,243.145c-3.63-4.486-10.211-5.179-14.695-1.548l-3.636,2.942c-4.485,3.631-5.177,10.211-1.546,14.696c2.066,2.551,5.083,3.875,8.128,3.875c2.309,0,4.634-0.762,6.568-2.328l3.635-2.942C413.21,254.209,413.903,247.63,410.272,243.145z" />
                                    </g>
                                    <g>
                                        <path d="M380.363,267.357c-3.63-4.486-10.211-5.179-14.695-1.549l-74.708,59.674c-4.485,3.631-5.177,10.21-1.546,14.695c2.064,2.551,5.082,3.875,8.127,3.875c2.309,0,4.634-0.762,6.568-2.327l74.708-59.674C383.301,278.421,383.994,271.843,380.363,267.357z" />
                                    </g>
                                    <g>
                                        <path d="M449.742,62.685H62.258C27.929,62.685,0,90.614,0,124.942v262.117c0,34.329,27.929,62.257,62.258,62.257h387.484c34.33,0,62.258-27.928,62.258-62.257V124.942C512,90.614,484.072,62.685,449.742,62.685z M419.912,83.582L255.859,216.19L91.806,83.582H419.912z M428.126,428.418H83.592V184.382l165.712,133.49c3.826,3.082,9.284,3.082,13.11,0l165.711-133.49V428.418z M491.102,387.058c0,22.806-18.554,41.359-41.36,41.359h-0.717v-265.87c0-4.023-2.309-7.688-5.939-9.425c-3.632-1.738-7.934-1.235-11.065,1.288L255.859,296.318L79.697,154.41c-3.134-2.523-7.438-3.026-11.065-1.288c-3.63,1.737-5.939,5.402-5.939,9.425v265.87h-0.436c-22.805,0.001-41.359-18.553-41.359-41.358V124.942c0-21.626,16.688-39.418,37.861-41.2l190.532,154.012c1.915,1.549,4.242,2.323,6.568,2.323c2.327,0,4.653-0.774,6.568-2.323L452.983,83.721c21.295,1.66,38.119,19.507,38.119,41.22V387.058z" />
                                    </g>

                                </svg>
                                echovaultsupport@gmail.com
                            </li>
                            <li>
                                Preserve your memories forever with EchoVault
                            </li>
                        </ul>
                    </div>
                    <div className="col-6 header__top_right">
                        <ul>
                            <li>
                                <Link to="https://facebook.com">
                                    <svg fill="#ffffff" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 50 50">
                                        <path d="M40,0H10C4.486,0,0,4.486,0,10v30c0,5.514,4.486,10,10,10h30c5.514,0,10-4.486,10-10V10C50,4.486,45.514,0,40,0z M39,17h-3 c-2.145,0-3,0.504-3,2v3h6l-1,6h-5v20h-7V28h-3v-6h3v-3c0-4.677,1.581-8,7-8c2.902,0,6,1,6,1V17z">
                                        </path>
                                    </svg>
                                </Link>
                            </li>
                            <li>
                                <Link to="https://instagram.com">
                                    <svg fill="#ffffff" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 169.063 169.063">
                                        <g>
                                            <path d="M122.406,0H46.654C20.929,0,0,20.93,0,46.655v75.752c0,25.726,20.929,46.655,46.654,46.655h75.752c25.727,0,46.656-20.93,46.656-46.655V46.655C169.063,20.93,148.133,0,122.406,0z M154.063,122.407c0,17.455-14.201,31.655-31.656,31.655H46.654C29.2,154.063,15,139.862,15,122.407V46.655C15,29.201,29.2,15,46.654,15h75.752c17.455,0,31.656,14.201,31.656,31.655V122.407z" />
                                            <path d="M84.531,40.97c-24.021,0-43.563,19.542-43.563,43.563c0,24.02,19.542,43.561,43.563,43.561s43.563-19.541,43.563-43.561C128.094,60.512,108.552,40.97,84.531,40.97z M84.531,113.093c-15.749,0-28.563-12.812-28.563-28.561c0-15.75,12.813-28.563,28.563-28.563s28.563,12.813,28.563,28.563C113.094,100.281,100.28,113.093,84.531,113.093z" />
                                            <path d="M129.921,28.251c-2.89,0-5.729,1.17-7.77,3.22c-2.051,2.04-3.23,4.88-3.23,7.78c0,2.891,1.18,5.73,3.23,7.78c2.04,2.04,4.88,3.22,7.77,3.22c2.9,0,5.73-1.18,7.78-3.22c2.05-2.05,3.22-4.89,3.22-7.78c0-2.9-1.17-5.74-3.22-7.78C135.661,29.421,132.821,28.251,129.921,28.251z" />
                                        </g>
                                    </svg>
                                </Link>
                            </li>
                            <li>
                                {user ? (
                                    <>
                                        <div className="user-avatar" ref={menuRef}>
                                            <img
                                                src={user.data.avatarUrl || "/default-avatar.jpeg"}
                                                alt="User Avatar"
                                                className="avatar"
                                            />
                                            <div onClick={toggleDropdown} className="user-toggle">
                                                <MdKeyboardArrowDown />
                                                <span>Hi, {user.data.displayName}</span>
                                            </div>

                                            {isOpen && (
                                                <div className="dropdown-menu">
                                                    <button onClick={() => navigate(ROUTERS.USER.PROFILE)}><AiOutlineProfile />  Profile</button>
                                                    <button onClick={() => navigate(ROUTERS.USER.CREATE)}><IoCreateOutline />  New Capsule</button>
                                                    <button
                                                        onClick={() => {
                                                            localStorage.clear(); // Clear all data from localStorage
                                                            alert("You have been logged out.");
                                                            window.location.reload(); // Optionally reload the page to reflect the logout state
                                                        }}
                                                    > <MdLogout />  Logout
                                                    </button>
                                                </div>

                                            )}
                                        </div>
                                        <Notification />
                                    </>
                                ) : (
                                    <GetStartedButton onLoginSuccess={handleLoginSuccess}
                                    />
                                )}
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <div className="backgroundColor">
            <div className="container">
                <div className="row">
                    <div className="col-xl-3 col-lg-3">
                        <div className="header__logo">
                            <h1> EchoVault</h1>
                        </div>
                    </div>
                    <div className="col-xl-6 col-lg-6 ">
                        <nav className="header__menu">
                            <ul>
                                {menus.map((menu, menuKey) => (
                                    <li
                                        key={menuKey}
                                        className={
                                            (menu.path === ROUTERS.USER.HOME && location.pathname === "/") ||
                                                (menu.name === "My Capsules" && location.pathname.startsWith("/my-capsule")) ||
                                                (menu.name === "Dashboard" && location.pathname.startsWith("/dashboard"))
                                                ? "active"
                                                : ""
                                        }
                                    >

                                        <Link to={menu.path}>{menu.name}</Link>
                                        {menu.child && (
                                            <ul className="header__menu__dropdown">
                                                {menu.child.map((childItem, childKey) => (
                                                    <li key={`${menuKey}-${childKey}`} className={location.pathname === childItem.path ? "active" : ""}>
                                                        <Link to={childItem.path}>{childItem.name}</Link>
                                                    </li>
                                                ))}
                                            </ul>
                                        )
                                        }
                                    </li>
                                ))
                                }

                            </ul>
                        </nav>
                    </div>
                    <div className="col-xl-3 col-lg-3">

                        <div className="humberger__open">
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={() => setShowHumberger(true)}>
                                <path d="M4 6H20M4 12H20M4 18H20" stroke="#000000" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div className="backgroundColor">
            <div className="container">
                <div className="row hero__categories_container">
                    <div className="col-lg-3  col-sm-12 col-md-12  hero__categories">

                    </div>

                    <div className="col-lg-9  col-sm-12 col-md-12 hero__search_container">
                        <div className="hero__search">
                            <div className="hero__search__form">
                            </div>
                        </div>
                    </div>
                </div>

                {isHome && (
                    <div className="hero__item">
                        <div className="hero__text">
                            <h2>
                                <span className="hero__text__echo">Echo</span>
                                <span className="hero__text__vault">Vault</span>
                            </h2>
                            <p> Preserve  your digital legacy in our secure time capsule </p>
                            <Link to={ROUTERS.USER.CREATE} className="first-btn">
                                Create Your Capsule Now
                            </Link>
                        </div>
                    </div>
                )}
            </div>
        </div>
    </>
    );
};

export default memo(Header);
